import { render, staticRenderFns } from "./CompanyCommercial.vue?vue&type=template&id=2e5e56a8&scoped=true"
import script from "./CompanyCommercial.vue?vue&type=script&lang=js"
export * from "./CompanyCommercial.vue?vue&type=script&lang=js"
import style0 from "./CompanyCommercial.vue?vue&type=style&index=0&id=2e5e56a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5e56a8",
  null
  
)

export default component.exports